import React from "react";
import { useIntl } from "react-intl";
import { Tooltip, IconButton } from "@folio/stripes/components";
import styles from "./HelpTooltip.module.css";
export var HelpTooltip = function (_a) {
    var id = _a.id, textId = _a.textId, _b = _a.placement, placement = _b === void 0 ? "right" : _b, _c = _a.icon, icon = _c === void 0 ? "info" : _c, _d = _a.hasLabel, hasLabel = _d === void 0 ? true : _d;
    var formatMessage = useIntl().formatMessage;
    var renderIcon = function (_a) {
        var ref = _a.ref, ariaIds = _a.ariaIds;
        return (React.createElement(IconButton, { ref: ref, icon: icon, "aria-labelledby": ariaIds.text, className: hasLabel ? styles.helpIcon : styles.helpIconNoLabel }));
    };
    return (React.createElement(Tooltip, { id: id, text: formatMessage({ id: textId }), placement: placement }, renderIcon));
};
